var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { AvailableRewardsTile, ChallengeTile, NewUnlockedTile, } from '../../TierBenefits/Rewards/RewardTiles';
export var rewardTileList = function (rewardList, inListDrawer, isMobile) {
    var slides = rewardList === null || rewardList === void 0 ? void 0 : rewardList.map(function (reward, index) {
        var rewardTileProps = {
            key: index,
            isMobile: isMobile,
            inListDrawer: inListDrawer,
        };
        if (reward.challengeId) {
            return React.createElement(ChallengeTile, __assign({ challenge: reward }, rewardTileProps));
        }
        if (reward.offerType === 'PERK' && reward.perkStatus === 'UNCLAIMED') {
            return React.createElement(NewUnlockedTile, __assign({ reward: reward }, rewardTileProps));
        }
        return React.createElement(AvailableRewardsTile, __assign({ reward: reward }, rewardTileProps));
    });
    return slides;
};
